<template>
        <transition name="loading-slide">
            <initial-loading-page v-if="!loaded"></initial-loading-page>
            <div v-else key="loaded">
                <full-page :options="options" id="fullpage" ref="fullpage">
                    <div class="section section-home">
                        <navbar v-if="loaded"></navbar>
                        <div v-for="slide in home.slides" :key="slide.background.url"
                             :style="{backgroundImage:'url('+baseUrl+slide.background.url+')'}"
                             class="slide" :class="{clickable: slide.url}" @click="openWindow(slide.url)">
                        </div>
                        <div class="year c-white" :class="{'ani-slideIn1':$store.state.initialLoad}">
                            <p><span class="t-number">{{new Date().getFullYear()-1999}}</span><span class="t-year">YEARS</span></p>
                            <p><span class="t-experience">EXPERIENCE</span></p>
                        </div>
                        <footerBar v-if="loaded" :currentIndex="currentSectionIndex"></footerBar>
                    </div>
                    <div class="section tab-container section-products">
                        <navbar v-if="loaded" :isWhiteLogo="currentProductTabIndex===5"></navbar>
                        <div class="tab-container1">
                            <div class="tab-nav">
                                <hover-flash-button v-for="(item, index) in products" class="f-GOTHICB"
                                    @click.native="toggleProductTab(index)"
                                    :text="item.name" is-foreground-black
                                    :style="{'transition-delay': (index*0.1)+'s'}"
                                    :class="{'tab-name-active': currentProductTabIndex === index}"/>
                            </div>
                            <div class="c-white dis-flex">
                                <transition name="tab-left-slidein">
                                    <div v-if="currentSectionIndex === 1" class="tab-left">
                                        <p class="arrows"><img src="../assets/images/arrows-white.png"/></p>
                                        <div class="tran-outer-container tran-left-products">
                                            <transition name="tab-slide">
                                                <div :key="currentProductTabIndex" class="tran-inner-container">
                                                    <p class="tab-title-line1 f-pdf-m"
                                                       :style="{textShadow:`3px 3px ${currentProduct.backgroundColor}, 4px 4px #fff, 4px 2px #fff, 2px 4px #fff`}">
                                                        {{firstProductLineTitle}}
                                                    </p>

                                                    <p class="tab-title-line2 f-pdf-m"
                                                       :style="{textShadow:`5px 3px ${currentProduct.backgroundColor}, 6px 4px #fff, 6px 2px #fff, 4px 4px #fff`}">
                                                        {{secondProductLineTitle}}
                                                    </p>

                                                    <p class="tab-introduction f-GOTHIC">
                                                        {{currentProduct.description}}</p>
                                                </div>
                                            </transition>
                                            <hover-flash-button is-router-link have-border text="View All →"
                                                                class="product-view-all-button f-GOTHICB"
                                                                :router-link-to="{name:'productList',params:{slug:currentProduct.slug}}"/>
                                        </div>
                                    </div>
                                </transition>
                                <transition name="tab-right-slidein">
                                    <div v-if="currentSectionIndex === 1" class="tab-right">
                                        <transition name="tab-slide">
                                            <img :key="currentProductTabIndex" :src="baseUrl+currentProduct.pic.url"
                                                 alt="">
                                        </transition>
                                    </div>
                                </transition>
                                <transition name="tab-background-slide">
                                    <div :style="{backgroundColor:currentProduct.backgroundColor}"
                                         :key="currentProductTabIndex"
                                         class="section-products-background"></div>
                                </transition>
                            </div>
                        </div>
                        <footerBar v-if="loaded" :currentIndex="currentSectionIndex"></footerBar>
                    </div>
                    <div class="section tab-container section-news">
                        <navbar v-if="loaded" :isWhiteLogo="currentNewsTabIndex===2"></navbar>
                        <div class="tab-container1">
                            <div class="tab-nav">
                                <hover-flash-button v-for="(item, index) in news" class="f-GOTHICB"
                                    @click.native="toggleNewsTab(index)"
                                    :text="item.name" is-foreground-black
                                    :style="{'transition-delay': (index*0.1)+'s'}"
                                    :class="{'tab-name-active': currentNewsTabIndex === index}"/>
                            </div>
                            <div class="c-white dis-flex">
                                <transition name="tab-left-slidein">
                                    <div v-if="currentSectionIndex === 2" class="tab-left">
                                        <p class="arrows"><img src="../assets/images/arrows-white.png"/></p>
                                        <div class="tran-outer-container tran-left-news">
                                            <transition name="tab-slide">
                                                <div :key="currentNewsTabIndex" class="tran-inner-container">

                                                    <p v-if="!!firstNewsLineTitle" class="tab-title-line1 f-pdf-m"
                                                       :style="{textShadow:`3px 3px ${currentNews.backgroundColor}, 4px 4px #fff, 4px 2px #fff, 2px 4px #fff`}">
                                                        {{firstNewsLineTitle}}
                                                    </p>
                                                    <p class="tab-title-line2 f-pdf-m"
                                                       :style="{textShadow:`5px 3px ${currentNews.backgroundColor}, 6px 4px #fff, 6px 2px #fff, 4px 4px #fff`}">
                                                        {{secondNewsLineTitle}}
                                                    </p>
                                                </div>
                                            </transition>
                                        </div>
                                        <hover-flash-button is-router-link have-border is-foreground-black
                                                            text="View All →"
                                                            class="news-view-all-button f-GOTHICB"
                                                            :router-link-to="{name:'newsList',params:{slug:currentNews.slug}}"/>
                                    </div>
                                </transition>
                                <transition name="tab-right-slidein">
                                    <div v-if="currentSectionIndex === 2" class="tab-news-right">
                                        <div class="tran-outer-container tran-news-right-container">
                                            <transition name="tab-slide">
                                                <div class="news-image-container" :key="currentNewsTabIndex">
                                                    <div v-if="currentNewsImage.tagPic" class="tag-pic-container">
                                                        <img :src="baseUrl+currentNewsImage.tagPic.url" alt="">
                                                    </div>
                                                    <div class="news-info">
                                                        <p class="display-time f-GOTHICB">
                                                            {{currentNewsDisplayTime}}</p>
                                                        <p class="description f-GOTHIC">
                                                            {{currentNewsImage.description}}</p>
                                                        <router-link
                                                                :to="{name:'news',params:{slug:currentNewsImage.slug,parent:currentNews.slug}}"
                                                                tag="p" class="learn-more f-GOTHICB">Learn More →
                                                        </router-link>
                                                    </div>
                                                    <img class="head-pic"
                                                         :src="baseUrl+currentNewsImage.headpic.url"
                                                         alt="">
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </transition>
                                <transition name="tab-background-slide">
                                    <div :style="{backgroundColor: currentNews.backgroundColor}"
                                         class="section-news-background" :key="currentNewsTabIndex"></div>
                                </transition>
                            </div>
                        </div>
                        <footerBar v-if="loaded" :currentIndex="currentSectionIndex"></footerBar>
                    </div>
                    <div class="section tab-container section-aboutUs">
                        <navbar v-if="loaded" :isWhiteLogo="currentAboutUsTabIndex===2"></navbar>
                        <div class="tab-container1">
                            <div class="tab-nav">
                                <hover-flash-button v-for="(name,index) in aboutUsNavfirstLine" class="f-GOTHICB"
                                    @click.native="toggleAboutUsTab(index)"
                                    :text="name" is-foreground-black
                                    :style="{'transition-delay': (index*0.1)+'s'}"
                                    :class="{'tab-name-active': currentAboutUsTabIndex === index}"/>
                            </div>
                            <div class="tab-nav">
                                <hover-flash-button v-for="(name,index) in aboutUsNavSecondLine" class="f-GOTHICB"
                                    @click.native="toggleAboutUsTab(index+aboutUsNavfirstLine.length)"
                                    :text="name" is-foreground-black
                                    :style="{'transition-delay': ((index+aboutUsNavfirstLine.length)*0.1)+'s'}"
                                    :class="{'tab-name-active': currentAboutUsTabIndex === (index+aboutUsNavfirstLine.length)}"/>
                            </div>
                            <div class="c-white">
                                <transition name="tab-left-slidein">
                                    <div v-if="currentSectionIndex === 3" class="tab-left">
                                        <p class="arrows"><img src="../assets/images/arrows-white.png"/></p>
                                        <div class="tran-outer-container tran-left-about-us">
                                            <transition name="tab-slide">
                                                <div :key="currentAboutUsTabIndex" class="tran-inner-container">
                                                    <p v-if="!!firstAboutUsLineTitle" class="tab-title-line1 f-pdf-m"
                                                       :style="{textShadow:`3px 3px ${currentAboutUs.backgroundColor}, 4px 4px #fff, 4px 2px #fff, 2px 4px #fff`}">
                                                        {{firstAboutUsLineTitle}}
                                                    </p>
                                                    <p class="tab-title-line2 f-pdf-m"
                                                       :style="{textShadow:`5px 3px ${currentAboutUs.backgroundColor}, 6px 4px #fff, 6px 2px #fff, 4px 4px #fff`}">
                                                        {{secondAboutUsLineTitle}}
                                                    </p>
                                                    <p v-if="currentAboutUs.certificates.length===0"
                                                       class="tab-introduction f-GOTHIC">
                                                        {{currentAboutUs.description}}
                                                    </p>
                                                    <div v-else class="certificate-images-container dis-flex"
                                                         ref="certificatesContainer">
                                                        <img v-for="img in currentAboutUs.certificates"
                                                             :src="baseUrl+img.url" alt="" class="certificate">
                                                    </div>
                                                    <hover-flash-button v-if="currentAboutUs.certificates.length===0"
                                                                        is-router-link have-border text="Learn More →"
                                                                        class="about-us-learn-more-button f-GOTHICB"
                                                                        :router-link-to="{name:'aboutUs',params:{slug:currentAboutUs.slug}}"/>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </transition>

                                <transition name="tab-background-slide">
                                    <div class="aboutUs-media-container" :key="currentAboutUsTabIndex"
                                         :style="{'z-index':currentAboutUsTabIndex!==0?-1:0}">
                                        <div v-if="currentAboutUsTabIndex!==0" class="aboutUs-media"
                                             :style="{backgroundImage:'url('+baseUrl+currentAboutUs.media.url+')'}">
                                        </div>
                                        <video v-else preload loop ref="aboutUsVideo" controls class="video"
                                               :src="baseUrl+currentAboutUs.video.url"></video>
                                    </div>
                                </transition>

                                <transition name="tab-background-slide">
                                    <div :key="currentAboutUsTabIndex"
                                         :style="{backgroundColor:currentAboutUs.backgroundColor}"
                                         class="section-aboutUs-background"></div>
                                </transition>
                            </div>
                        </div>
                        <footerBar v-if="loaded" :currentIndex="currentSectionIndex"></footerBar>
                    </div>
                    <div class="section tab-container section-contactUs">
                        <navbar v-if="loaded"></navbar>
                        <div class="tab-container1">
                            <div class="dis-flex">
                                <transition name="tab-left-slidein">
                                    <div v-if="currentSectionIndex === 4" class="contactUs-left c-black">
                                        <p class="contact-arrows"><img src="../assets/images/arrows-black.png"/></p>
                                        <contact-us-info></contact-us-info>
                                    </div>
                                </transition>
                                <transition name="tab-right-slidein">
                                    <div v-if="currentSectionIndex === 4" class="contactUs-right f-DIN-Regular">
                                        <p class="f-GOTHIC">We are here to answer any questions you may have about our
                                            products and services. Reach out to us and we will respond as soon as we
                                            can, If you have any special requests. </p>
                                        <inquiry-form class="form" textarea-height="3.2rem"/>
                                    </div>
                                </transition>
                            </div>
                        </div>
                        <footerBar v-if="loaded" :currentIndex="currentSectionIndex"></footerBar>
                    </div>
                </full-page>
            </div>
        </transition>
</template>

<script>
    // @ is an alias to /src
    import navbar from '@/components/Navbar.vue'
    import footerBar from '@/components/FooterBar.vue'
    import CircleProgress from '@/components/CircleProgress.vue'
    import HoverFlashButton from '@/components/HoverFlashButton.vue'
    import 'fullpage.js/dist/fullpage.css'
    import dayjs from 'dayjs'
    import {mapState} from 'vuex';
    import 'viewerjs/dist/viewer.css';
    import Viewer from 'viewerjs';
    import {allowBodyHorizontalScroll, isWideScreen} from '../utils'
    import {homeDataMixin} from '../mixins'

    export default {
        name: 'Home',
        mixins: [homeDataMixin],
        components: {
            navbar,
            footerBar,
            CircleProgress,
            HoverFlashButton,
        },
        beforeRouteUpdate(to, from, next) {
            this.$refs.fullpage.api.moveTo(to.hash.slice(1))
            next()
        },
        beforeRouteEnter(to, from, next){
            next(vm=>{
                let tabIndex=parseInt(vm.$route.query.tabIndex)
                if(from.name==='productList') {
                    vm.currentProductTabIndex = tabIndex
                }else if(from.name==='newsList') {
                    vm.currentNewsTabIndex = tabIndex
                }else if(from.name==='aboutUs') {
                    vm.currentAboutUsTabIndex=tabIndex
                }
            })
        },
        data() {
            return {
                hasClicked: false,
                currentSectionIndex: 0,
                currentProductTabIndex: 0,
                currentNewsTabIndex: 0,
                currentAboutUsTabIndex: 0,
                options: {
                    anchors: ['home', 'products', 'news', 'about-us', 'contact-us'],
                    afterRender: this.afterRender,
                    afterLoad: this.afterLoad,
                    onSlideLeave: this.onSlideLeave,
                    onLeave: this.onLeave,
                    navigation: true,
                    navigationPosition: 'left',
                    navigationTooltips: ['HOME', 'PRODUCTS', 'NEWS', 'ABOUT US', 'CONTACT US'],
                    showActiveTooltip: true,
                    slidesNavigation: true,
                    controlArrows: false,
                    easingcss3: 'cubic-bezier(0.91, 0.03, 0.12, 1)',
                    scrollingSpeed: 1000,
                    responsiveWidth: 480,
                    normalScrollElements: '.search-container'
                },
            }
        },
        computed: {
            ...mapState(['fullPageScrolling']),
            currentProduct: function () {
                return this.products[this.currentProductTabIndex]
            },
            firstProductLineTitle: function () {
                return this.getFirstLineTitle(this.currentProduct)
            },
            secondProductLineTitle: function () {
                return this.getSecondLineTitle(this.currentProduct)
            },
            currentNews: function () {
                return this.news[this.currentNewsTabIndex]
            },
            currentNewsImage: function () {
                return this.newsImages[this.currentNewsTabIndex][0]
            },
            currentNewsDisplayTime: function () {
                let time = this.currentNewsImage.displayTime
                return dayjs(time).format('MMM D,YYYY')
            },
            firstNewsLineTitle: function () {
                return this.getFirstLineTitle(this.currentNews)
            },
            secondNewsLineTitle: function () {
                return this.getSecondLineTitle(this.currentNews)
            },
            currentAboutUs: function () {
                return this.aboutUs[this.currentAboutUsTabIndex]
            },
            firstAboutUsLineTitle: function () {
                return this.getFirstLineTitle(this.currentAboutUs)
            },
            secondAboutUsLineTitle: function () {
                return this.getSecondLineTitle(this.currentAboutUs)
            },
            aboutUsNavfirstLine: function () {
                return this.aboutUs.filter(e => e.lineOfTab !== 2).map(e => e.name)
            },
            aboutUsNavSecondLine: function () {
                return this.aboutUs.filter(e => e.lineOfTab === 2).map(e => e.name)
            },
            isPlaying: function () {
                return this.currentSectionIndex === 3 && this.currentAboutUsTabIndex === 0
            },
        },
        watch: {
            currentSectionIndex(newValue) {
                if (newValue === 4) {
                    document.querySelectorAll('#fp-nav ul li .fp-tooltip')[4].style.setProperty('color', 'black')
                    document.querySelectorAll('#fp-nav ul li a span').forEach(item => item.style.setProperty('border-color', 'black'))
                    document.querySelectorAll('#fp-nav ul li a.active span').forEach(item => item.style.setProperty('background-color', 'black'))
                } else {
                    document.querySelectorAll('#fp-nav ul li .fp-tooltip')[4].style.setProperty('color', 'white')
                    document.querySelectorAll('#fp-nav ul li a span').forEach(item => item.style.setProperty('border-color', 'white'))
                    document.querySelectorAll('#fp-nav ul li a span').forEach(item => item.style.setProperty('background-color', 'transparent'))
                    document.querySelectorAll('#fp-nav ul li a.active span').forEach(item => item.style.setProperty('background-color', 'white'))
                }
                this.setupCertificateViewer()
            },
            isPlaying(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        if (this.aboutUsVideoCurrentTime === undefined) {
                            this.aboutUsVideoCurrentTime = 0
                        }
                        this.$refs.aboutUsVideo.currentTime = this.aboutUsVideoCurrentTime
                        this.$refs.aboutUsVideo.play();
                    })
                } else {
                    if (this.$refs.aboutUsVideo) {
                        this.aboutUsVideoCurrentTime = this.$refs.aboutUsVideo.currentTime
                        this.$refs.aboutUsVideo.pause();
                    }
                }
            },
            currentAboutUs() {
                this.setupCertificateViewer()
            },
            fullPageScrolling(newValue) {
                this.$refs.fullpage.api.setAllowScrolling(newValue);

            }
        },
        methods: {
            setupCertificateViewer() {
                let certificatesViewer
                if (this.currentSectionIndex === 3 && this.currentAboutUs.certificates.length !== 0) {
                    this.$nextTick(() => {
                        certificatesViewer = new Viewer(this.$refs.certificatesContainer, {
                            title: false,
                            show: () => this.$refs.fullpage.api.setAllowScrolling(false),
                            hidden: () => this.$refs.fullpage.api.setAllowScrolling(true),
                        });
                    })
                } else {
                    if (certificatesViewer) {
                        certificatesViewer.destroy();
                    }
                }
            },
            addSlideInClassForFpnav() {
                const nav = document.querySelector('#fp-nav');
                nav.classList.add('ani-slideInNav')
            },
            addSlideInClassForFpSlideNav() {
                const slideNav = document.querySelector('.fp-slidesNav');
                slideNav.classList.add('ani-slideInForSlideNav')
            },
            afterRender() {
                !isWideScreen && allowBodyHorizontalScroll()
                if (this.$store.state.initialLoad) {
                    this.addSlideInClassForFpnav()
                    this.addSlideInClassForFpSlideNav()
                }
            },
            createSlideMoveTimer() {
                this.slideMoveTimer = setTimeout(() => {
                    this.$refs.fullpage && this.$refs.fullpage.api.moveSlideRight()
                }, (this.home.slideSwitchInterval || 7) * 1000)
            },
            clearSlideMoveTimer() {
                clearTimeout(this.slideMoveTimer)
            },
            afterLoad(origin, destination, direction) {
                if (destination.index === 0) {
                    this.createSlideMoveTimer()
                }
            },
            onSlideLeave(section, origin, destination, direction) {
                this.clearSlideMoveTimer()
                this.createSlideMoveTimer()
            },
            onLeave(origin, destination, direction) {
                setTimeout(() => this.currentSectionIndex = destination.index, 500)
                if (destination.index !== 0) {
                    this.clearSlideMoveTimer()
                }
            },
            toggleProductTab(index) {
                if (this.hasClicked) return
                this.updateClickStatus()
                this.currentProductTabIndex = index
            },
            toggleNewsTab(index) {
                if (this.hasClicked) return
                this.updateClickStatus()
                this.currentNewsTabIndex = index
            },
            toggleAboutUsTab(index) {
                if (this.hasClicked) return
                this.updateClickStatus()
                this.currentAboutUsTabIndex = index
            },
            updateClickStatus() {
                this.hasClicked = true;
                setTimeout(() => {
                    this.hasClicked = false
                }, 1000)
            },
            openWindow(url) {
                if (url) {
                    window.open(url, '_blank')
                }
            }
        }
    }
</script>
<style>
    #fp-nav {
        z-index: 1;
    }

    #fp-nav ul li a span {
        border: solid 1px #ffffff;
        opacity: 0.8;
        background: none;
    }

    #fp-nav ul li a.active span {
        background-color: #ffffff;
        opacity: 1;
    }

    #fp-nav ul li .fp-tooltip {
        font-size: 13px;
        top: 0;
        font-family: GOTHICB, sans-serif;
    }

    #fp-nav.fp-left {
        left: 100px;
    }

    .fp-slidesNav {
        text-align: center;
        z-index: 1;
    }

    .fp-slidesNav.fp-bottom {
        bottom: 55px;
    }

    .fp-slidesNav ul li a span {
        background: #888;
        width: 8px;
        height: 8px;
        margin: -4px 0 0 -4px;
    }

    .fp-slidesNav ul li a.active span {
        background: #fff;
        width: 8px;
        height: 8px;
        margin: -4px 0 0 -4px;
    }

    .fp-slidesNav ul li:hover a.active span {
        width: 10px;
        height: 10px;
        margin: -5px 0 0 -5px;
    }

    .section {
        box-sizing: content-box;
    }

    .section-home .fp-tableCell {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .slide {
        background-size: cover;
        background-position: center;
    }

    .slide.clickable {
        cursor: pointer;
    }

    .tab-container .fp-tableCell {
        vertical-align: unset;
    }

    @keyframes slideInNav {
        0% {
            transform: translate3d(-100vw, -50%, 0);
            opacity: 0;
        }
        100% {
            transform: translate3d(0, -50%, 0);
            opacity: 1;
        }
    }

    .ani-slideInNav {
        animation: slideInNav 1s 1.7s backwards;
    }

    @keyframes slideInForSlideNav {
        0% {
            transform: translate3d(-100vw, 0, 0);
            opacity: 0;
        }
        100% {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }

    .ani-slideInForSlideNav {
        animation: slideInForSlideNav 1s 1.2s backwards;
    }

</style>
<style scoped>
    .tab-container1 {
        padding: 148px 0 0 248px
    }

    .tab-nav {
        display: flex;
    }

    .tab-nav button {
        font-size: 14.8px;
        padding: 0 10px;
        line-height: 41px;
        cursor: pointer;
        border-radius: 0;
        background-color: transparent;
    }

    .tab-nav button::after {
        content: "";
        position: absolute;
        top: 0;
        right: 1px;
        height: 100%;
        width: 1px;
        background-color:#000;
    }

    .tab-nav button:not(:first-child) {
        transform: translate3d(-100%, 0, 0);
        opacity: 0;
        transition: 0.8s opacity cubic-bezier(0.91, 0.03, 0.12, 1), 0.8s transform cubic-bezier(0.91, 0.03, 0.12, 1);
    }

    .active .tab-nav button:not(:first-child) {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    button.tab-name-active {
        font-size: 30px;
        padding: 0 14px;
    }

    button.tab-name-active::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 14px;
        height: 2px;
        width: calc(100% - 28px);
        background-color: #000;
    }

    button:first-child.tab-name-active {
        padding-left: 0;
    }

    button:first-child.tab-name-active::before {
        left: 0;
        width: calc(100% - 14px);
    }

    .tab-left {
        width: 857px;
        position: relative;
    }

    .tab-left-slidein-enter {
        transform: translate3d(0, 15%, 0);
    }

    .tab-left-slidein-enter-active {
        transition: 1s ease-out;
    }

    .tab-left .arrows {
        width: 114px;
        height: 12px;
        margin: 48px 0 23px 0;
    }

    .tab-left .arrows img {
        display: block;
        width: 100%;
    }

    .tab-title-line1 {
        font-size: 100px;
        line-height: 0.7;
        padding-bottom: 18px;
    }

    .tab-title-line2 {
        font-size: 185px;
        line-height: 0.7;
    }

    .tab-introduction {
        width: 538px;
        margin-top: 30px;
        font-size: 15px;
        line-height: 1.2;
    }

    .tab-right {
        width: 383px;
        height: 514px;
        margin-top: 68px;
        overflow: hidden;
        background-color: white;
    }

    .tab-right img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .tab-right-slidein-enter {
        transform: translate3d(0, 30%, 0);
    }

    .tab-right-slidein-enter-active {
        transition: 1.6s ease-out;
    }

    .section-products, .section-news, .section-aboutUs {
        position: relative;
    }

    .section-products .product-view-all-button {
        position: absolute;
        top: 484px;
    }

    .section-products-background, .section-news-background, .section-aboutUs-background {
        background-image: url("../assets/images/background.png");
    }

    .section-products-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 1316px;
        height: 100%;
        z-index: -99;
    }

    .tab-news-right {
        margin-top: -56px;
        position: relative;
    }

    .news-image-container {
        width: 523px;
        height: 706px;
        overflow: hidden;
        background-color: white;
    }

    .news-image-container .tag-pic-container {
        position: absolute;
        top: -10px;
        right: -27px;
        width: 155px;
        height: 129px;
    }

    .news-image-container .tag-pic-container img {
        width: 100%;
    }

    .news-image-container .news-info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 175px;
        background-color: #000000;
        opacity: 0.75;
        padding: 23px;
        box-sizing: border-box;
    }

    .news-image-container .display-time {
        font-size: 16px;
        margin-bottom: 17px;
    }

    .news-image-container .description {
        font-size: 15px;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .news-image-container .learn-more {
        font-size: 20px;
        color: #06c59a;
        text-align: right;
        cursor: pointer;
        margin-top: 39px;
    }

    .news-image-container .head-pic {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .section-news-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 586px;
        z-index: -99;
    }

    .section-news .tab-left {
        position: relative;
    }

    .section-news .news-view-all-button {
        position: absolute;
        top: 423px;
    }

    .section-aboutUs .tab-left, .section-aboutUs .tab-introduction {
        width: 421px;
    }

    .section-aboutUs .tab-left .arrows {
        margin: 25px 0 20px 0;
    }

    .section-aboutUs .about-us-learn-more-button {
        margin-top: 80px;
    }

    .certificate-images-container {
        margin-top: 33px;
    }

    .certificate-images-container img {
        width: 222px;
        height: 313px;
        display: inline-block;
        margin-right: 10px;
    }

    .certificate {
        cursor: pointer;
    }

    .aboutUs-media-container {
        position: absolute;
        right: 0;
        top: 0;
        width: 1095px;
        height: 100%;
    }

    .aboutUs-media {
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    .section-aboutUs-background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -99;
        width: 825px;
        height: 100%;
    }

    .video {
        height: 100%;
        width: 100%;
        object-fit: cover;
        outline: none;
        object-position: center;
    }

    .contactUs-left {
        width: 550px;
        padding-right: 240px;
    }

    .contactUs-left .contact-arrows {
        width: 114px;
        height: 12px;
        margin-bottom: 23px;
    }

    .contactUs-left .contact-arrows img {
        width: 100%;
    }

    .contact-info {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        padding: 20px 0;
        line-height: 1.5;
        margin-top: 13px;
    }

    .company-name {
        font-size: 33px;
        padding-top: 33px;
    }

    .contactUs-right {
        margin-top: 34px;
        width: 505px;
        line-height: 1.5;
    }

    .contactUs-right .form {
        margin-top: 23px;
    }

    .year {
        position: absolute;
        right: 45px;
        bottom: 109px;
        z-index: 1;
    }

    .year .t-number {
        font-size: 125px;
        letter-spacing: 2px;
        font-family: pfd-Bold-4, sans-serif;
        line-height: 0;
        margin-left: -5px;
    }

    .year .t-year {
        font-size: 24px;
        font-family: pfd-light-6, sans-serif;
    }

    .year .t-experience {
        font-size: 40px;
        font-family: pfd-Medium-3, sans-serif;
        line-height: 0.6;
    }

    .loading-slide-leave-active, .loading-slide-enter-active {
        transition: transform 1s cubic-bezier(0.91, 0.03, 0.12, 1);
    }

    .loading-slide-leave-to {
        transform: translate3d(0, 100vh, 0)
    }

    .loading-slide-enter {
        transform: translate3d(0, -100vh, 0);
    }

    .tran-outer-container {
        overflow: hidden
    }

    .tran-inner-container {
        height: 100%;
    }

    .tran-left-products {
        height: 398px;
    }

    .tran-left-news {
        height: 338px;
    }

    .tran-left-about-us {
        height: 550px;
        width: 760px;
    }

    .tran-news-right-container {
        height: 706px;
    }

    .tab-slide-enter-active, .tab-slide-leave-active {
        transition: transform 1s cubic-bezier(0.91, 0.03, 0.12, 1)
    }

    .tab-slide-enter-to, .tab-slide-leave-to {
        transform: translate3d(0, -100%, 0);
    }

    .tab-background-slide-enter-active, .tab-background-slide-leave-active {
        transition: transform 1s cubic-bezier(0.91, 0.03, 0.12, 1)
    }

    .tab-background-slide-enter {
        transform: translate3d(0, 100%, 0);
    }

    .tab-background-slide-leave-to {
        transform: translate3d(0, -100%, 0);
    }

    @keyframes slideIn {
        0% {
            transform: translate3d(-100vw, 0, 0);
            opacity: 0;
        }
        100% {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }

    .ani-slideIn1 {
        animation: slideIn 1s 1s backwards;
    }
</style>

